import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import styles from "../styles/adminBrandsComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";
import { AdminInstance } from "../utils/adminClass";
import { UsStateInstance } from "../utils/usStateClass";
import { ImageScaleAndCropComponent } from "./imageScaleAndCropComponent";

export const AdminAddBrandFormComponent = ({
  editing = false,
  setReset,
  closeForm,
  data,
  setInputs,
}: {
  editing: Boolean;
  setReset: Function;
  closeForm: Function;
  data: any;
  setInputs: any;
}) => {
  const [brandDetails, setBrandDetails] = useState<Record<string, any>>({
    stateId: 28,
  });

  const [canSubmit, setCanSubmit] = useState(editing);

  const requiredFields = [
    "brandName",
    //'email',
    "website",
    "stateId",
    // "licenseNumber",
  ];

  const { states, isLoading } = useSelector((state: any) => state.state);
  //for adding images
  const [selectedThumbnail, setSelectedThumbnail] = useState<File | null>(null);
  const [selectedDisplayImage, setSelectedDisplayImage] = useState<File | null>(null);
  const [isCropVisible, setIsCropVisible] = useState<{
    thumb: boolean;
    display: boolean;
  }>({
    thumb: false,
    display: false,
  });

  const [imageSrc, setImageSrc] = useState<{
    thumb: string | null;
    display: string | null;
  }>({
    thumb: null,
    display: null,
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setBrandDetails({
      ...brandDetails,
      [name]: value,
    });
  };

  //checks if we can submit
  useEffect(() => {
    const isFilled = requiredFields.every((field) => brandDetails[field]);
    setCanSubmit(isFilled || editing);
    console.log("brand deets", brandDetails);
  }, [brandDetails]);

  //when we have data from updating our brand
  useEffect(() => {
    UsStateInstance.getUsStates();
    console.log("DATA", data);
    if (data) {
      setBrandDetails({
        ...brandDetails,
        ...data,
      });
      setImageSrc((prev) => ({ ...prev, display: data.displayUrl }));
      setImageSrc((prev) => ({ ...prev, thumb: data.avatarUrl }));
    }
    console.log("BRAND DETAILS IS NOW", brandDetails);
  }, [data]);

  const handleImageCropped = async (croppedImageUrl: string, type: "thumb" | "display") => {
    // Convert the cropped image URL to a Blob
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();
    console.log("HERE BE OUR BLOB", blob);
    // Create a File object from the Blob
    const fileExt = blob.type.split("/")[1]; // Extracts the file extension from the MIME type
    const fileName = `cropped_image.${fileExt}`; // Constructs a file name
    const croppedImageFile = new File([blob], fileName, { type: blob.type });
    // Generate a URL for the cropped image file
    const croppedImageURL = URL.createObjectURL(croppedImageFile);
    console.log("HERE BE THE IMAGE FILE", croppedImageFile);
    console.log("IMAGE URL BE HERE", croppedImageURL);

    // Update the appropriate state with the new File object
    if (type === "thumb") {
      setSelectedThumbnail(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, thumb: croppedImageURL }));
    } else if (type === "display") {
      setSelectedDisplayImage(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, display: croppedImageURL }));
    }

    // Hide the cropping modal
    setIsCropVisible((prev) => ({ ...prev, [type]: false }));
    return;
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>, type: "thumb" | "display") => {
    const file = event.target.files ? event.target.files[0] : null;
    console.log("HERE BE DEH FILE", file);
    if (file) {
      const fileURL = URL.createObjectURL(file);
      if (type === "thumb") {
        setSelectedThumbnail(file);
      } else {
        setSelectedDisplayImage(file);
      }
      setImageSrc((prev) => ({ ...prev, [type]: fileURL }));
      setIsCropVisible((prev) => ({ ...prev, [type]: true }));
    }
  };

  const handleDisplayImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "display");
  };

  const handleThumbnailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "thumb");
  };

  const handleForm = async (e: any) => {
    e.preventDefault();
    try {
      if (editing) {
        //adding in image updates to our brandDetails;
        const withImages = {
          ...brandDetails,
          displayImg: selectedDisplayImage,
          avatarImg: selectedThumbnail,
        };
        console.log("here be updated deets with images", withImages);
        const updatedBrand = await AdminInstance.updateBrand(brandDetails.id, withImages, brandDetails.name);
        console.log("here be updated brand", updatedBrand);
        //await AdminInstance.updateBrand(brandDetails.id, brandDetails, brandDetails.name);
      } else {
        // console.log('here be the brand', brandDetails);
        await AdminInstance.addBrandToDB({
          brandName: brandDetails.brandName,
          email: brandDetails.email,
          website: brandDetails.website,
          city: brandDetails.city,
          stateId: brandDetails.stateId,
          licenseNumber: brandDetails.licenseNumber,
          displayImg: selectedDisplayImage,
          avatarImg: selectedThumbnail,
        });
      }
      setReset();
    } catch (error) {
      console.log(`failed form submission with error: ${error}`);
      console.error(error);
    }
  };

  return (
    <Form className={styles.wrapper} id="addbrandForm">
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Brand Name</Form.Label>
        <Form.Control
          type="text"
          name={editing ? "name" : "brandName"}
          placeholder="Brand Name"
          onChange={handleInputChange}
          value={brandDetails.name}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicWebsiteURL">
        <Form.Label>Website URL</Form.Label>
        <Form.Control
          type="url"
          name="website"
          placeholder="Enter Website URL"
          onChange={handleInputChange}
          value={brandDetails.website}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Display Image (optional)</Form.Label>
        <div className={styles.thumbnailWrapper}>
          <>
            {isCropVisible.display && (
              <ImageScaleAndCropComponent
                setSrc={(croppedImgUrl: any) => {
                  handleImageCropped(croppedImgUrl, "display");
                  //handleImageCropped(croppedImgUrl, 'thumb');
                }}
                imageType="displayImage"
                src={imageSrc.display}
                handleClose={() => setIsCropVisible((prev) => ({ ...prev, display: false }))}
              />
            )}
          </>
          <div
            style={{
              margin: "0 auto 10px auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imageSrc.display ? (
              <img
                src={
                  imageSrc.display
                    ? imageSrc.display
                    : selectedDisplayImage
                      ? URL.createObjectURL(selectedDisplayImage)
                      : "https://via.placeholder.com/150"
                }
                alt="display image"
              />
            ) : (
              <div className={styles.imagePlaceHolder}>
                <h3>1080 x 1080</h3>
              </div>
            )}
          </div>
          <input type="file" onChange={handleDisplayImageChange} accept="image/png, image/jpeg, image/jpg" />
          <p>
            Set the Brand Display image. Please select an image that is 1080 x 1080. Only *.png, *.jpg and *.jpeg image
            files are accepted
          </p>
        </div>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Avatar Image (optional)</Form.Label>
        <div className={styles.thumbnailWrapper}>
          <>
            {isCropVisible.thumb && (
              <ImageScaleAndCropComponent
                setSrc={(croppedImgUrl: any) => {
                  //handleImageCropped(croppedImgUrl, 'display');
                  handleImageCropped(croppedImgUrl, "thumb");
                }}
                imageType="avatar"
                src={imageSrc.thumb}
                handleClose={() => setIsCropVisible((prev) => ({ ...prev, thumb: false }))}
              />
            )}
          </>
          <div
            style={{
              margin: "0 auto 10px auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imageSrc.thumb ? (
              <img
                src={
                  imageSrc.thumb
                    ? imageSrc.thumb
                    : selectedThumbnail
                      ? URL.createObjectURL(selectedThumbnail)
                      : "https://via.placeholder.com/150"
                }
                alt="avatar image"
              />
            ) : (
              <div className={styles.imagePlaceHolder}>
                <h3>600 x 600</h3>
              </div>
            )}
          </div>
          <input type="file" onChange={handleThumbnailChange} accept="image/png, image/jpeg, image/jpg" />
          <p>
            Set the Brand Avatar image. Please select an image that is 600 x 600. Only *.png, *.jpg and *.jpeg image
            files are accepted
          </p>
        </div>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicState">
        <Form.Label>State</Form.Label>
        <div>
          <select
            value={brandDetails.stateId}
            name=""
            id=""
            onChange={(e) =>
              setBrandDetails({
                ...brandDetails,
                stateId: Math.floor(Number(e.target.value)),
              })
            }
          >
            {states.map((state: any) => (
              <option key={state.id} value={state.id}>
                {state.label}
              </option>
            ))}
          </select>
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicBusinessLicense">
        <Form.Label>Business License</Form.Label>
        <Form.Control
          type="text"
          name="licenseNumber"
          placeholder="Business License Number"
          onChange={handleInputChange}
          value={brandDetails.licenseNumber}
        />
      </Form.Group>
      <Button className={btnStyles.Submit} disabled={!canSubmit} variant="primary" type="submit" onClick={handleForm}>
        {editing ? "Submit Changes" : "Create Brand"}
      </Button>
    </Form>
  );
};
